import { useAdministrativeContext } from '../../../../../pages/administrativePanel/administrativePanelContext'
import { useState, useEffect, useCallback } from 'react'
import {createContext, useContext} from 'react'
import { useHistory } from 'react-router'
import { toast } from 'react-toastify'
import { api } from '../../../../../services/api'
import { useAuth } from '../../../../../context/AuthContext'

export const CouponAndModalFormsContext = createContext()


export function CouponAndModalFormsProvider({ children }){
    const { listBusinessToFilter,franchiseListCodesSelected } = useAdministrativeContext()
    const { signOut } = useAuth()

    const [coupons, setCoupons] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [couponDatasToCreateOrEdit, setCouponDatasToCreateOrEdit] = useState({noEndDate: false})
    const [totalCoupons, setTotalCoupons] = useState(0)

    const history = useHistory()

    let isCouponAreaVisible = listBusinessToFilter.length === 1  

    const fetchData = useCallback(async () => {
        /*if(listBusinessToFilter.length > 1){
            setCoupons([])
            setIsLoading(false)
            return
        }*/

        try{
            await api.get(`/getCoupons/?business=${listBusinessToFilter}&getAll=1`, {
                headers: {
                    token: localStorage.getItem('@Inoveclube:token')
                }
            }).then(response => {
                setCoupons(response.data)
            });
            
            setIsLoading(false);

        }catch(error){
            if(error.response.status === 401 || error.response.status === 500){
                signOut()
                toast.warning('Sua sessão foi expirada')
            }else{
                toast.error(error.response.data.message)
                history.push('/profile')
            }
        }
    }, [signOut, listBusinessToFilter, history])


    useEffect(() =>{
        fetchData()
        return () => setCoupons([])
    },[fetchData])

    
    return(
        <CouponAndModalFormsContext.Provider 
            value={ { 
                coupons, setCoupons,
                isLoading,
                listBusinessToFilter,
                couponDatasToCreateOrEdit, setCouponDatasToCreateOrEdit,
                totalCoupons, setTotalCoupons,
                isCouponAreaVisible,
                fetchData,
                franchiseListCodesSelected
            } }
        >
            { children }
        </CouponAndModalFormsContext.Provider>
    )
}



export function useCouponAndModalForms() {
   const context = useContext(CouponAndModalFormsContext)

   if(!context) {
    throw new Error('useCouponAndModalForms must be used within an Provider');
  } 

   return context
}
